var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgCreateSyncariRecord = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#563BCE",
    d: "M21.75 12c0 5.385-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12 6.615 2.25 12 2.25s9.75 4.365 9.75 9.75"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#EBEBFA",
    d: "M17.25 15.938a.263.263 0 0 0-.262-.263h-.6v-.6a.263.263 0 0 0-.526 0v.6h-.6a.26.26 0 0 0-.262.26v.002c0 .146.118.263.262.263h.6v.6c0 .144.117.261.26.262h.003a.263.263 0 0 0 .262-.262v-.6h.6a.263.263 0 0 0 .263-.262"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#EBEBFA",
    fillRule: "evenodd",
    d: "M18.375 15.938a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0m-2.25 1.687a1.687 1.687 0 1 0 0-3.375 1.687 1.687 0 0 0 0 3.375",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#EBEBFA",
    d: "m15.204 9.706-1.61 1.089 1.61 1.217v-.639s.617.23.631.959a1 1 0 0 1-.297.663 3 3 0 0 1 1.23.012q.1-.28.107-.638c-.01-1.782-1.671-2.006-1.671-2.006zm-1.558 4.541c.24-.351.553-.649.917-.871h-.043c-.887-.017-1.287-.608-1.332-1.007-.003-.02-.08-1.86-.09-2.163-.01-.318-.304-1.933-2.339-1.956-1.835-.004-2.327 1.496-2.428 1.805l-.013.037-.018.006c-.287.088-1.97.608-1.924 2.271.048 1.705 1.45 1.992 2.114 1.997.665.004 1.96 0 1.96 0V15l1.466-1.088-1.465-1.197v.74c-.203 0-.444.002-.69.005-.503.006-1.025.012-1.27-.006-.494-.026-1.018-.385-1.076-1.085-.057-.699.801-1.202 1.075-1.28.293-.093.611-.093.888-.093h.015c0-.254.044-.547.082-.79.057-.189.444-1 1.284-.966.797-.037 1.19.549 1.214.966.01.167.014.395.019.672.007.415.016.94.048 1.53.043.778.606 1.55 1.607 1.839Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCreateSyncariRecord);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/create-syncari-record.405f6094.svg";